import IconProps from '@/interfaces/icon'

export const UserIcon = ({
  className = '',
  width = '16',
  height = '19',
}: {
  className?: string
  width?: string
  height?: string
}) => {
  return (
    <span className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 16 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.8125 10.9375H6.4375C2.99219 10.9375 0.25 13.7148 0.25 17.125C0.25 17.7578 0.742188 18.25 1.375 18.25H14.875C15.4727 18.25 16 17.7578 16 17.125C16 13.7148 13.2227 10.9375 9.8125 10.9375ZM1.9375 16.5625C2.21875 14.3477 4.11719 12.625 6.4375 12.625H9.8125C12.0977 12.625 13.9961 14.3477 14.2773 16.5625H1.9375ZM8.125 9.25C10.5859 9.25 12.625 7.24609 12.625 4.75C12.625 2.28906 10.5859 0.25 8.125 0.25C5.62891 0.25 3.625 2.28906 3.625 4.75C3.625 7.24609 5.62891 9.25 8.125 9.25ZM8.125 1.9375C9.67188 1.9375 10.9375 3.20312 10.9375 4.75C10.9375 6.33203 9.67188 7.5625 8.125 7.5625C6.54297 7.5625 5.3125 6.33203 5.3125 4.75C5.3125 3.20312 6.54297 1.9375 8.125 1.9375Z"
          fill="#464646"
        />
      </svg>
    </span>
  )
}

export const DashboardIcon = ({
  className = '',
  width = '21',
  height = '17',
}: {
  className?: string
  width?: string
  height?: string
}) => {
  return (
    <span className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 21 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.62767 5.4375C5.99486 5.4375 5.50267 5.96484 5.50267 6.5625C5.50267 7.19531 5.99486 7.6875 6.62767 7.6875C7.22533 7.6875 7.75267 7.19531 7.75267 6.5625C7.75267 5.96484 7.22533 5.4375 6.62767 5.4375ZM4.94017 9.375C4.30736 9.375 3.81517 9.90234 3.81517 10.5C3.81517 11.1328 4.30736 11.625 4.94017 11.625C5.53783 11.625 6.06517 11.1328 6.06517 10.5C6.06517 9.90234 5.53783 9.375 4.94017 9.375ZM15.0652 10.5C15.0652 11.1328 15.5574 11.625 16.1902 11.625C16.7878 11.625 17.3152 11.1328 17.3152 10.5C17.3152 9.90234 16.7878 9.375 16.1902 9.375C15.5574 9.375 15.0652 9.90234 15.0652 10.5ZM10.5652 0.375C4.97533 0.375 0.44017 4.91016 0.44017 10.5C0.44017 12.3633 0.932358 14.1211 1.81126 15.5977C1.98705 15.9492 2.37376 16.125 2.76048 16.125H18.3347C18.7214 16.125 19.1081 15.9492 19.3191 15.5977C20.1628 14.1211 20.6902 12.3633 20.6902 10.5C20.6902 4.91016 16.155 0.375 10.5652 0.375ZM10.5652 14.4375C9.75658 14.4375 9.15892 13.8398 9.15892 13.0312C9.15892 12.2578 9.75658 11.625 10.5652 11.625C11.3386 11.625 11.9714 12.2578 11.9714 13.0312C11.9714 13.8398 11.3386 14.4375 10.5652 14.4375ZM18.0183 14.4375H13.2722C13.5183 14.0156 13.6589 13.5586 13.6589 13.0312C13.6589 12.2227 13.3074 11.4492 12.78 10.8867L15.487 6.77344C15.7331 6.38672 15.6277 5.85938 15.241 5.57812C14.8191 5.33203 14.3269 5.4375 14.0456 5.82422L11.3035 10.043C11.0574 10.0078 10.8113 9.9375 10.5652 9.9375C8.84251 9.9375 7.47142 11.3438 7.47142 13.0312C7.47142 13.5586 7.57689 14.0156 7.82298 14.4375H3.07689C2.44408 13.2422 2.12767 11.9062 2.12767 10.5C2.12767 5.85938 5.88939 2.0625 10.5652 2.0625C15.2058 2.0625 19.0027 5.85938 19.0027 10.5C19.0027 11.9062 18.6511 13.2422 18.0183 14.4375ZM10.5652 3.75C9.93236 3.75 9.44017 4.27734 9.44017 4.875C9.44017 5.50781 9.93236 6 10.5652 6C11.1628 6 11.6902 5.50781 11.6902 4.875C11.6902 4.27734 11.1628 3.75 10.5652 3.75Z"
          fill="#464646"
        />
      </svg>
    </span>
  )
}

export const BriefcaseIcon = ({
  className = '',
  width = '19',
  height = '18',
}: {
  className?: string
  width?: string
  height?: string
}) => {
  return (
    <span className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.3416 3.625H14.0916V2.5C14.0916 1.26953 13.072 0.25 11.8416 0.25H7.34157C6.07595 0.25 5.09157 1.26953 5.09157 2.5V3.625H2.84157C1.57595 3.625 0.591574 4.64453 0.591574 5.875V14.875C0.591574 16.1406 1.57595 17.125 2.84157 17.125H16.3416C17.572 17.125 18.5916 16.1406 18.5916 14.875V5.875C18.5916 4.64453 17.572 3.625 16.3416 3.625ZM7.34157 1.9375H11.8416C12.1228 1.9375 12.4041 2.21875 12.4041 2.5V3.625H6.77907V2.5C6.77907 2.21875 7.02517 1.9375 7.34157 1.9375ZM2.84157 5.3125H16.3416C16.6228 5.3125 16.9041 5.59375 16.9041 5.875V9.25H2.27907V5.875C2.27907 5.59375 2.52517 5.3125 2.84157 5.3125ZM16.3416 15.4375H2.84157C2.52517 15.4375 2.27907 15.1914 2.27907 14.875V10.9375H7.34157V11.5C7.34157 12.1328 7.83376 12.625 8.46657 12.625H10.7166C11.3142 12.625 11.8416 12.1328 11.8416 11.5V10.9375H16.9041V14.875C16.9041 15.1914 16.6228 15.4375 16.3416 15.4375Z"
          fill="#464646"
        />
      </svg>
    </span>
  )
}

export const CalenderIcon = ({
  className = '',
  width = '17',
  height = '19',
}: {
  className?: string
  width?: string
  height?: string
}) => {
  return (
    <span className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 17 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.2758 2.5H12.8696V1.09375C12.8696 0.636719 12.4829 0.25 12.0258 0.25C11.5337 0.25 11.1821 0.636719 11.1821 1.09375V2.5H6.11959V1.09375C6.11959 0.636719 5.73287 0.25 5.27584 0.25C4.78366 0.25 4.43209 0.636719 4.43209 1.09375V2.5H3.02584C1.76022 2.5 0.775843 3.51953 0.775843 4.75V16C0.775843 17.2656 1.76022 18.25 3.02584 18.25H14.2758C15.5063 18.25 16.5258 17.2656 16.5258 16V4.75C16.5258 3.51953 15.5063 2.5 14.2758 2.5ZM14.2758 16.5625H3.02584C2.70944 16.5625 2.46334 16.3164 2.46334 16V7H14.8383V16C14.8383 16.3164 14.5571 16.5625 14.2758 16.5625Z"
          fill="#464646"
        />
      </svg>
    </span>
  )
}

export const BooksIcon = ({
  className = '',
  width = '21',
  height = '21',
}: {
  className?: string
  width?: string
  height?: string
}) => {
  return (
    <span className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9219 17.5312L15.7031 1.90625C15.4688 1.08594 14.7266 0.5 13.9062 0.5C13.75 0.5 13.5938 0.539062 13.3984 0.578125L11.0156 1.24219C10.7812 1.28125 10.5469 1.39844 10.3906 1.51562C10.0781 0.929688 9.45312 0.5 8.75 0.5H6.25C5.89844 0.5 5.58594 0.617188 5.3125 0.773438C5 0.617188 4.6875 0.5 4.375 0.5H1.875C0.820312 0.5 0 1.35938 0 2.375V18.625C0 19.6797 0.820312 20.5 1.875 20.5H4.375C4.6875 20.5 5 20.4219 5.3125 20.2656C5.58594 20.4219 5.89844 20.5 6.25 20.5H8.75C9.76562 20.5 10.625 19.6797 10.625 18.625V6.98438L13.8672 19.1328C14.1016 19.9531 14.8438 20.5 15.7031 20.5C15.8594 20.5 16.0156 20.5 16.1719 20.4609L18.5938 19.7969C19.6094 19.5625 20.1953 18.5078 19.9219 17.5312ZM8.75 2.375V4.25H6.25V2.375H8.75ZM6.25 6.125H8.75V14.875H6.25V6.125ZM4.375 14.875H1.875V6.125H4.375V14.875ZM4.375 2.375V4.25H1.875V2.375H4.375ZM1.875 18.625V16.75H4.375V18.625H1.875ZM6.25 18.625V16.75H8.75V18.625H6.25ZM11.4844 3.03906L13.9062 2.41406V2.375L14.375 4.17188L11.9531 4.83594L11.4844 3.03906ZM12.4609 6.63281L14.8828 6.00781L17.1484 14.4062L14.7266 15.0312L12.4609 6.63281ZM15.7031 18.6641L15.1953 16.8672L17.6172 16.2031L18.125 18L15.7031 18.6641Z"
          fill="#464646"
        />
      </svg>
    </span>
  )
}

export const MegaPhoneIcon = ({
  className = '',
  width = '41',
  height = '33',
}: {
  className?: string
  width?: string
  height?: string
}) => {
  return (
    <span className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 41 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M39.3125 0.75C38.3281 0.75 37.625 1.52344 37.625 2.4375V2.71875L3.73438 12.2109C3.59375 11.5078 2.96094 10.875 2.1875 10.875C1.20312 10.875 0.5 11.6484 0.5 12.5625V20.4375C0.5 21.4219 1.20312 22.125 2.1875 22.125C2.96094 22.125 3.59375 21.5625 3.73438 20.8594L12.2422 23.25C11.8906 24.0234 11.75 24.9375 11.75 25.7812C11.75 29.3672 14.6328 32.25 18.2188 32.25C21.4531 32.25 24.125 29.8594 24.5469 26.6953L37.625 30.3516V30.5625C37.625 31.5469 38.3281 32.25 39.3125 32.25C40.2266 32.25 41 31.5469 41 30.5625V2.4375C41 1.52344 40.2266 0.75 39.3125 0.75ZM21.3125 25.7812C21.3125 27.5391 19.9062 28.875 18.2188 28.875C16.4609 28.875 15.125 27.5391 15.125 25.7812C15.125 25.2188 15.2656 24.6562 15.6172 24.1641L21.2422 25.7812H21.3125ZM3.875 17.3438V15.7266L37.625 6.23438V26.8359L3.875 17.3438Z"
          fill="#464646"
        />
      </svg>
    </span>
  )
}

export const CommentsIcon = ({
  className = '',
  width = '46',
  height = '37',
}: {
  className?: string
  width?: string
  height?: string
}) => {
  return (
    <span className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 46 37"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.625 15.9688C14.7812 15.9688 14.2188 16.6016 14.2188 17.375C14.2188 18.2188 14.7812 18.7812 15.625 18.7812C16.3984 18.7812 17.0312 18.2188 17.0312 17.375C17.0312 16.6016 16.3984 15.9688 15.625 15.9688ZM16.5391 6.6875H14.4297C12.6719 6.6875 11.2656 8.09375 11.2656 9.85156C11.2656 10.4844 11.7578 10.9766 12.3906 10.9766C13.0234 10.9766 13.5156 10.4844 13.5156 9.85156C13.5156 9.35938 13.9375 8.9375 14.4297 8.9375H16.5391C17.1719 8.9375 17.6641 9.42969 17.6641 10.0625C17.6641 10.4844 17.3828 10.8359 17.0312 11.0469L15.0625 12.0312C14.7109 12.1719 14.5 12.5938 14.5 13.0156V14C14.5 14.6328 14.9922 15.125 15.625 15.125C16.1875 15.125 16.75 14.6328 16.75 14V13.7188L18.0156 13.0156C19.2109 12.4531 19.9141 11.3281 19.9141 10.0625C19.9141 8.23438 18.3672 6.6875 16.5391 6.6875ZM43.1172 31.7188C44.875 29.6094 46 27.0078 46 24.125C46 17.3047 39.9531 11.75 32.5 11.75C32.4297 11.75 32.4297 11.8203 32.4297 11.8203C32.4297 12.1719 32.5 12.5234 32.5 12.875C32.5 19.8359 26.875 25.6719 19.3516 27.1484C20.8281 32.5625 26.1016 36.5 32.5 36.5C34.8203 36.5 37.0703 35.9375 38.9688 35.0234C40.7266 35.8672 42.9062 36.5 45.4375 36.5C45.6484 36.5 45.8594 36.4297 45.9297 36.2188C46 36.0078 46 35.7969 45.7891 35.6562C45.7891 35.5859 44.2422 33.9688 43.1172 31.7188ZM39.1094 22.8594L33.2031 29.0469C32.9219 29.3281 32.5703 29.4688 32.2188 29.4688C31.7969 29.4688 31.4453 29.3281 31.1641 29.1172L28.3516 26.3047C27.8594 25.7422 27.8594 24.8281 28.3516 24.2656C28.9141 23.7734 29.8281 23.7734 30.3906 24.2656L32.1484 26.0938L37.0703 20.9609C37.6328 20.3984 38.4766 20.3281 39.0391 20.8906C39.6016 21.4531 39.6719 22.2969 39.1094 22.8594ZM30.25 12.875C30.25 6.05469 23.6406 0.5 15.625 0.5C7.53906 0.5 1 6.05469 1 12.875C1 15.8281 2.19531 18.5 4.16406 20.6094C3.03906 22.8594 1.49219 24.5469 1.42188 24.5469C0.929688 25.1094 0.859375 25.8125 1.14062 26.4453C1.35156 27.1484 1.98438 27.5 2.6875 27.5C6.55469 27.5 9.64844 26.1641 11.7578 24.8281C13.0234 25.1094 14.2891 25.25 15.625 25.25C23.6406 25.25 30.25 19.7656 30.25 12.875ZM15.625 21.875C14.5703 21.875 13.5859 21.8047 12.5312 21.5234L11.1953 21.2422L10 21.9453C8.80469 22.7188 7.60938 23.2812 6.34375 23.6328C6.625 23.1406 6.90625 22.6484 7.1875 22.2266L8.3125 20.0469L6.625 18.2891C5.57031 17.2344 4.375 15.4062 4.375 12.875C4.375 7.95312 9.36719 3.875 15.625 3.875C21.8125 3.875 26.875 7.95312 26.875 12.875C26.875 17.8672 21.8125 21.875 15.625 21.875Z"
          fill="#464646"
        />
      </svg>
    </span>
  )
}

export const CloseIcon = ({
  className = '',
  width = '20',
  height = '20',
}: IconProps) => {
  return (
    <span className={`icon ${className}`} >
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M18.5312 16.7812L11.5586 9.75L18.5312 2.77734C19.1172 2.25 19.1172 1.37109 18.5312 0.84375C18.0039 0.257812 17.125 0.257812 16.5977 0.84375L9.625 7.81641L2.59375 0.84375C2.06641 0.257812 1.1875 0.257812 0.660156 0.84375C0.0742188 1.37109 0.0742188 2.25 0.660156 2.77734L7.63281 9.75L0.660156 16.7812C0.0742188 17.3086 0.0742188 18.1875 0.660156 18.7148C1.1875 19.3008 2.06641 19.3008 2.59375 18.7148L9.625 11.7422L16.5977 18.7148C17.125 19.3008 18.0039 19.3008 18.5312 18.7148C19.1172 18.1875 19.1172 17.3086 18.5312 16.7812Z" />
      </svg>
    </span>
  )
}

export const HamburgerIcon = ({
  className = '',
  width = '27',
  height = '23',
}: {
  className?: string
  width?: string
  height?: string
}) => {
  return (
    <span className={`icon ${className}`}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 27 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M25.5938 19.7188H2.15625C1.33594 19.7188 0.75 20.3633 0.75 21.125C0.75 21.9453 1.33594 22.5312 2.15625 22.5312H25.5938C26.3555 22.5312 27 21.9453 27 21.125C27 20.3633 26.3555 19.7188 25.5938 19.7188ZM25.5938 0.96875H2.15625C1.33594 0.96875 0.75 1.61328 0.75 2.375C0.75 3.19531 1.33594 3.78125 2.15625 3.78125H25.5938C26.3555 3.78125 27 3.19531 27 2.375C27 1.61328 26.3555 0.96875 25.5938 0.96875ZM25.5938 10.3438H2.15625C1.33594 10.3438 0.75 10.9883 0.75 11.75C0.75 12.5703 1.33594 13.1562 2.15625 13.1562H25.5938C26.3555 13.1562 27 12.5703 27 11.75C27 10.9883 26.3555 10.3438 25.5938 10.3438Z" />
      </svg>
    </span>
  )
}
